(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["helmut-back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('helmut-back-in-stock')) {
    customElements.define(
      'helmut-back-in-stock',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-bis-dialog]');
          this.variantSelect = this.querySelector('[data-bis-variant]');
          this.tagsInput = this.querySelector('[data-bis-tags]');

          this.querySelector('[data-bis-open]')?.addEventListener('click', () => this.dialog?.showModal());
          this.querySelector('[data-bis-close]')?.addEventListener('click', () => this.dialog?.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.variantSelect?.addEventListener('change', () => this.updateTags());
          this.updateTags();

          if (this.querySelector('[data-state]')) this.dialog?.showModal();
        }

        updateTags() {
          if (!this.tagsInput || !this.variantSelect?.value) return;
          this.tagsInput.value = [
            this.dataset.baseTag,
            this.dataset.modelTag,
            `bis-variant-${this.variantSelect.value}`,
          ].join(',');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
